// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Modal":"uoj69RqA","content":"Qo1C8ZYL"};